import React from "react";
import { useWindowDimensions } from "@app/hooks";
import CurrencyModalHeader from "./CurrencyModalHeader.tsx";
import CurrencyModalBody from "./CurrencyModalBody.tsx";
import { LanguageModalWrapper } from "./styles";

const CurrencyModal = ({ closeModal }: any) => {
  const { width: w, height } = useWindowDimensions();
  const wSize =
    w > 1400 ? w / 3.4 : w > 1200 ? w / 2.8 : w > 1200 ? w / 2.2 : w / 2.2;

  return (
    <LanguageModalWrapper
      style={{ width: wSize, height: height / 3.6, minHeight: 230 }}
    >
      <CurrencyModalHeader closeModal={closeModal} />
      <CurrencyModalBody closeModal={closeModal} />
    </LanguageModalWrapper>
  );
};

export default CurrencyModal;
